module.exports = __webpack_public_path__ + "static/images/logout.e3f2481e4d501f41d0a56f3541b6e086.svg";